module.exports = __webpack_public_path__ + "fonts/Brygada_1918-400-greek3.2e97762.woff2";